import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { RESOURCES } from './resources';

i18next.use(initReactI18next).init({
  resources: RESOURCES,
  lng: 'en',
  fallbackLng: ['en', 'it'],
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  // react-i18next v12+ defaults useSuspense to true; v10 (previous) did not
  // suspend. The app wraps no translated subtree in a <Suspense> boundary, so
  // keep the v10 non-suspending behaviour to avoid an unguarded suspend under
  // React 18. (Resources are inlined and init is synchronous, so `ready` is
  // immediately true in production regardless — this is purely defensive.)
  react: {
    useSuspense: false,
  },
});

export default i18next;
